module.exports = __webpack_public_path__ + "img/48.356e6769.jpg";